export const environment = {
  production: false,
  test       : true,
  name: 'test',
  hmr       : false,
  apiBaseUrl: 'https://pfeffersternbackendapi.ibexfusion.com',
};
